const navConfig = [
  {
    title: "Home",
    path: "/",
  },
  {
    title: "The Award",
    path: "/the-award",
  },
  {
    title: "Award Categories",
    path: "/award-categories",
  },
  {
    title: "2023 Shortlisted Nominees",
    path: "/2023-shortlisted-nominees",
  },
  {
    title: "2022 Shortlisted Nominees",
    path: "/2022-shortlisted-nominees",
  },
  {
    title: "Our Judges",
    path: "/our-judges",
  },
  {
    title: "2023 ACA Winners",
    path: "/2023-aca-winners",
  },
  {
    title: "2022 ACA Winners",
    path: "/2022-aca-winners",
  },
  {
    title: "Blog",
    path: "/blog",
  },
];

export default navConfig;
